import api from './api';

export const ocrApi = {
  parseInvoice: (data: FormData) => api.post('/api/vendor/finance/ocr/parse', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
};
